export const ALUMNOS_DATA_BD = {

};